import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IAttachmentActionsProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useAttachmentContext
} from "../../context";
import {
    warnOnce
} from "../../../../utils/development";

const AttachmentActions: FC<IAttachmentActionsProps> = ({
    customTheme,
    children,
    style,
    ...props
}) => {
    const context = useAttachmentContext();

    const {
        shapeConfigs,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme ?? context?.customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        shapeConfigs,
        spaces
    });

    if(!context) {
        warnOnce({
            message: "Attachment.Actions: it must be rendered inside an Attachment."
        });

        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {children}
    </View>;
};
export default AttachmentActions;
